import { Component, OnInit } from '@angular/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { count } from 'console';
@Component({
  selector: 'app-import-dtc-list-view',
  templateUrl: './import-dtc-list-view.component.html',
  styleUrls: ['./import-dtc-list-view.component.scss']
})
export class ImportDtcListViewComponent implements OnInit {

  tokenParams: any;
  dtcList: any[] = [];
  selectedRowIds: Set<string> = new Set<string>();
  showloader:boolean = true;
  disableImportDTCBtn: boolean = true;
  disableSymptomsSelectionBtn: boolean = true;
  customerComments: string = '';
  sessionId: string = ''
  isHistoricalDTCPresent: boolean = true;
  constructor(public service: ApifirstService, public translateService: TranslateService, public router: Router) { }

  ngOnInit(): void {
    this.service.tokenObj.subscribe((data)=> {
      this.tokenParams = data;
    })
    this.service.captureCustomerComments.subscribe((data:any)=> {
     this.customerComments = data.comment;
     this.sessionId = data.sessionId
    })
    this.requestDTCData();
  }

  requestDTCData() {
   this.service.getDTCData(this.tokenParams.vin,this.tokenParams.username,this.tokenParams.userType,this.tokenParams.language.toLowerCase(),this.tokenParams.countryThree,this.tokenParams.dealerCode,-1).subscribe((data)=> {
    this.dtcList = data.historyDtc;
    this.disableSymptomsSelectionBtn = false;
    this.dtcList = [...new Set(this.dtcList)];
    console.log('DTC LIST', this.dtcList);
    if(Object.keys(this.dtcList).length > 0) {
      this.isHistoricalDTCPresent = true;
    } else {
      this.isHistoricalDTCPresent = false;
    }
    this.showloader = false;
   })
  
  }
  onRowClick(count: string) {
    if(this.selectedRowIds.has(count)) {
     this.selectedRowIds.delete(count);
    }
    else {
      this.selectedRowIds.add(count);
      console.log('Added DTC', this.selectedRowIds);
    }
    this.getSelectedRowCount();
  }

  getSelectedRowCount() {
    if(this.selectedRowIds.size > 0) {
      this.disableImportDTCBtn = false;
    } else {
      this.disableImportDTCBtn = true;
    }
  }

  rowIsSelected(count: any) {
    return this.selectedRowIds.has(count);
  }

  getSelectedRows(){
    return this.dtcList.filter((x:any) => this.selectedRowIds.has(x.count));
  }

  importDTCData() {
    console.log(this.getSelectedRows());
     let selectedDTC = this.getSelectedRows();
    const request= {
      sessionId:this.sessionId,
      comment:this.customerComments,
      dtcInfo:"Yes",
      dtcListView: selectedDTC
      };
      this.service.insertSymptoms(request)
      .subscribe((data) => {
        console.log('dtc insert response:', data);
      })
    this.router.navigate(['/symptoms'])
  }

  NavigateSymptomSelection() {
    const request= {
      sessionId:this.sessionId,
      comment:this.customerComments,
      dtcInfo:"No",
      dtcListView: [{}]
      };
      this.service.insertSymptoms(request)
      .subscribe((data) => {
        console.log('DTC EXIT BTN CLICKinsert response:', data);
      })
    this.router.navigate(['/symptoms'])
  }
}
